import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=fd489a52&scoped=true&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=fd489a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd489a52",
  null
  
)

export default component.exports